module.exports = __webpack_public_path__ + "img/logo3.acf8c70f.png";